import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UiProperties } from '../models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CustomizeUiResource {
  private http = inject(HttpClient);

  getUiProperties(): Observable<UiProperties> {
    return this.http.get<UiProperties>('/services/system/admin/ui-customizations');
  }

  saveUiProperties(formData: FormData): Observable<void> {
    return this.http.put<void>('/services/system/admin/ui-customizations/file-upload', formData);
  }

  deleteImage(type: 'LOGO' | 'BACKGROUND_IMAGE'): Observable<void> {
    return this.http.delete<void>(`/services/system/admin/ui-customizations?type=${type}`);
  }
}
